export default "__VITE_ASSET__CUvKF07A__"